import React from 'react';
import { FadeIn } from './FadeIn';
export function Achievements() {
  const achievements = [{
    emoji: '📖',
    text: 'No necesitás ser docente. El sistema guía todo paso a paso.',
    bg: 'bg-kid-purple/10',
    border: 'border-kid-purple/20'
  }, {
    emoji: '🧠',
    text: 'Solo 10 minutos al día. Sin sesiones largas ni complicadas.',
    bg: 'bg-kid-pink/10',
    border: 'border-kid-pink/20'
  }, {
    emoji: '🎯',
    text: 'Método claro y progresivo. Cada actividad tiene un propósito.',
    bg: 'bg-kid-sky/10',
    border: 'border-kid-sky/20'
  }, {
    emoji: '⚡',
    text: 'Diseñado para evitar frustración. Tu hijo avanza a su ritmo.',
    bg: 'bg-kid-yellow/10',
    border: 'border-kid-yellow/20'
  }, {
    emoji: '📚',
    text: 'Actividades imprimibles listas para usar desde el primer día.',
    bg: 'bg-kid-lime/10',
    border: 'border-kid-lime/20'
  }];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-lime/5 via-kid-yellow/5 to-white relative overflow-hidden" data-id="element-23">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-24">
        <FadeIn data-id="element-25">
          <div className="text-center mb-6 md:mb-12" data-id="element-26">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-27">
              ¿Por qué funciona este sistema?
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-lime to-kid-yellow mx-auto rounded-full" data-id="element-28"></div>
          </div>
        </FadeIn>

        <div className="w-full" data-id="element-29">
          <div className="space-y-3" data-id="element-30">
            {achievements.map((item, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-31">
                <div className="flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-32">
                  <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${item.bg} border ${item.border} flex items-center justify-center flex-shrink-0 text-2xl md:text-3xl`} data-id="element-33">
                    {item.emoji}
                  </div>
                  <p className="text-gray-700 font-medium text-sm md:text-base leading-snug md:leading-relaxed" data-id="element-34">
                    {item.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}